import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { AppHeaderComponent } from 'src/domains/theme/app/component/app-header/app-header.component';

@Component({
  selector: 'app-main-page-layout',
  templateUrl: './main-page-layout.component.html',
  styleUrls: ['./main-page-layout.component.scss'],
  imports: [AppHeaderComponent, FooterComponent, RouterOutlet],
})
export class MainPageLayoutComponent {}
